<template>
  <div class="w-full h-full"></div>
</template>

<script>
import { firebase } from '@/firebase'

export default {
  name: 'Login',
  mounted: function() {
    if (!firebase.auth().currentUser) {
      this.$modal.show('modal--login')
    }
  }
}
</script>
